import {CanActivateFn, Router} from '@angular/router';
import {inject} from '@angular/core';
import {AuthService} from '@core/services/auth.service';

export const authGuard: CanActivateFn = (route, state) => {
  const router = inject(Router);
  const authService = inject(AuthService);

  const isAuthenticated = authService.isAuthenticated();
  console.log(isAuthenticated, 'isAuthenticated');
  if (!isAuthenticated) {
    if (!state.url.includes('/auth/login') || !state.url.includes('/')) {
      authService.forceLogout();
    }
    return false;
  }

  return true;
};
